export interface ResolveMapWorkbenchPopupPresentationArgs {
  isAuthorMode: boolean;
  hasHoveredFeature: boolean;
  hasPinnedFeature: boolean;
  hasActiveHoverPopup: boolean;
  hasActivePinnedPopup: boolean;
  authoredPinnedPopupIsPinned: boolean;
}

export interface MapWorkbenchPopupPresentation {
  featureSource: 'hover' | 'pinned' | null;
  pinned: boolean;
}

export function resolveMapWorkbenchPopupPresentation(
  args: ResolveMapWorkbenchPopupPresentationArgs,
): MapWorkbenchPopupPresentation {
  if (!args.isAuthorMode) {
    return {
      featureSource: args.hasHoveredFeature ? 'hover' : null,
      pinned: false,
    };
  }

  if (args.authoredPinnedPopupIsPinned && args.hasPinnedFeature) {
    return {
      featureSource: 'pinned',
      pinned: true,
    };
  }

  if (args.hasHoveredFeature && args.hasActiveHoverPopup) {
    return {
      featureSource: 'hover',
      pinned: false,
    };
  }

  if (args.hasPinnedFeature && args.hasActivePinnedPopup) {
    return {
      featureSource: 'pinned',
      pinned: false,
    };
  }

  return {
    featureSource: null,
    pinned: false,
  };
}
